import { useSelector } from 'react-redux';
import { selectIsIdentificationNeeded, selectIsPublishToHiddenBase } from '../../../../selectors/publishAvailable';
import { selectAutoProlongTooltipText, selectIsAutoProlongAvailable } from '../../../../selectors/checkoutInfo';
import { selectSummaryViewMode } from '../../../../selectors/elementsVisibility';
import { EElementsVisibilitySummaryView } from '../../../../types/reducers/elementsVisibility';
import { Device } from '../../../common/Device';
import { SummaryMobile } from '../SummaryMobile';
import { SummaryDesktop } from '../SummaryDesktop';
import { NeedIdentification } from '../../../NeedIdentification';
import { HiddenBaseContainer } from '../../../HiddenBase';
import { MultilineTotalContainer } from '../../../MultilineTotal';
import * as React from 'react';

export const SummaryContent = () => {
  const isIdentificationNeeded = useSelector(selectIsIdentificationNeeded);
  const isPublishToHiddenBase = useSelector(selectIsPublishToHiddenBase);
  const isAutoProlongAvailable = useSelector(selectIsAutoProlongAvailable);
  const autoProlongTooltipText = useSelector(selectAutoProlongTooltipText);
  const summaryViewMode = useSelector(selectSummaryViewMode);

  const showMultilineTotal = summaryViewMode === EElementsVisibilitySummaryView.Multiline;

  if (isIdentificationNeeded) {
    return <NeedIdentification />;
  }

  if (isPublishToHiddenBase) {
    return <HiddenBaseContainer />;
  }

  if (showMultilineTotal) {
    return <MultilineTotalContainer />;
  }

  return (
    <Device
      mobile={
        <SummaryMobile isAutoProlongVisible={isAutoProlongAvailable} autoProlongTooltipText={autoProlongTooltipText} />
      }
      desktop={<SummaryDesktop />}
    />
  );
};
